export const ServicesIcon = ({
  className = "",
  animateOnHover = false,
}: {
  className?: string;
  animateOnHover?: boolean;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className={`bi bi-gear-wide-connected transition-all duration-300 ${
      animateOnHover ? "group-hover:scale-110 group-hover:text-cyan-600" : ""
    } ${className}`}
    viewBox="0 0 16 16"
  >
    <path d="M7.443 2.04a.5.5 0 0 1 .113.0l.793 1.92a2.5 2.5 0 0 0 1.052 1.052l1.92.793a.5.5 0 0 1 0 .113l-1.92.793a2.5 2.5 0 0 0-1.052 1.052l-.793 1.92a.5.5 0 0 1-.113 0l-.793-1.92a2.5 2.5 0 0 0-1.052-1.052l-1.92-.793a.5.5 0 0 1 0-.113l1.92-.793a2.5 2.5 0 0 0 1.052-1.052zM6.974 6.374a.5.5 0 1 0-.948.316 3.5 3.5 0 0 1-.652 1.306.5.5 0 1 0 .708.708 4.5 4.5 0 0 0 .892-2.33" />
    <path d="M8.5 1.75A6.5 6.5 0 1 0 15 8.25a.5.5 0 0 1 1 0 7.5 7.5 0 1 1-7.5-7.5.5.5 0 0 1 0 1m-1.293 6.1a.5.5 0 0 1 .39.125l.73.73.73-.73a.5.5 0 0 1 .708.707l-.73.73.73.73a.5.5 0 0 1-.707.708l-.73-.73-.73.73a.5.5 0 1 1-.708-.708l.73-.73-.73-.73a.5.5 0 0 1 .317-.852Z" />
  </svg>
);
